import {
  RECEIVE_ACCOUNT_ID,
  RECEIVE_COMPANY_POLICY_ID,
  RECEIVE_APPLICATION_MENU,
  RECEIVE_PENDING_ITEMS,
  FETCH_EMPLOYEES,
  EMPLOYEES_LOADED,
  COMPANY_PROFILE_LOADED,
  START_INITIAL_SYNC,
  UPLOADED_EMPLOYEE,
  DELETED_EMPLOYEE,
  EDITED_EMPLOYEE,
  REPLACE_EMPLOYEES,
  RECEIVE_OWNERS_AS_EMPLOYEES,
  UPDATE_OWNER_AS_EMPLOYEE,
  UPDATE_COST_ESTIMATION_EMPLOYEES,
  UPDATE_REQUESTED_LIFE_PLANS_TO_QUOTE,
  INITIAL_STATE_LOADED,
} from "EmployerApplication/Actions";
import { INITIAL_STATE_LOAD_SUCCESS } from "QuotePage/Actions";
import { reducer as reduxFormReducer } from "redux-form";

import { REPLACE_EMPLOYEE_PROFILE } from "Common/EnterAges/actionTypes";
import { emptyEmployeeProfile } from "Common/EnterAges/Reducers";

export function accountId(state = null, action) {
  switch (action.type) {
    case RECEIVE_ACCOUNT_ID:
      return action.payload;
    default:
      return state;
  }
}

export function companyPolicyId(state = null, action) {
  switch (action.type) {
    case RECEIVE_COMPANY_POLICY_ID:
      return action.payload.companyPolicyId;
    case INITIAL_STATE_LOADED:
      return action.payload.companyPolicyId;
    default:
      return state;
  }
}

export function siteConfig(state = {}, action) {
  switch (action.type) {
    case RECEIVE_APPLICATION_MENU:
      return action.payload.siteConfig;
    default:
      return state;
  }
}

export function pendingItems(state = {}, action) {
  switch (action.type) {
    case RECEIVE_PENDING_ITEMS:
      return action.payload;
    default:
      return state;
  }
}

export const RESOURCE_STATES = {
  LOADING: "loading",
  READY: "ready",
};

export function resourceStates(state = {}, action) {
  switch (action.type) {
    case START_INITIAL_SYNC:
      return { ...state, employees: RESOURCE_STATES.LOADING };
    case FETCH_EMPLOYEES:
      return { ...state, employees: RESOURCE_STATES.LOADING };
    case EMPLOYEES_LOADED:
      return { ...state, employees: RESOURCE_STATES.READY };
    case COMPANY_PROFILE_LOADED:
      return { ...state, companyProfile: RESOURCE_STATES.READY };
    default:
      return state;
  }
}

// https://github.com/erikras/redux-form/issues/2971
// This logic is a work around since the provided reset function this.props.reset()
// does not function correctly
// Case 1: return values undefined, resets fields and runs validation,
// valid/invalid prop still works
// Case 2: return entire form state undefined, resets fields and does not run
// validation until user input, valid/invalid prop still works
// If this is ever fixed upstream, check to make sure this still works (it should)
export const reduxFormReducerWithReset = reduxFormReducer.plugin({
  eligibility: (state, action) => {
    switch (action.type) {
      case UPLOADED_EMPLOYEE:
        if (state && state.values.employees) {
          const newEmployees = {
            ...state.values.employees,
            [action.employee.hash_id]: {
              is_eligible: action.employee.is_eligible.toString(),
            },
          };

          const newValues = { ...state.values, employees: newEmployees };
          return { ...state, newValues };
        }
        return state;

      case DELETED_EMPLOYEE:
        if (state && state.values.employees) {
          const currentEmployees = state.values.employees;
          const { [action.hash_id]: _deleted, ...newEmployees } = currentEmployees;
          const newValues = { ...state.values, employees: newEmployees };
          return { ...state, newValues };
        }
        return state;

      default:
        return state;
    }
  },
});

export function employees(state = {}, action) {
  switch (action.type) {
    case REPLACE_EMPLOYEES:
      return { ...state, ...action.payload };
    case UPLOADED_EMPLOYEE:
    case EDITED_EMPLOYEE:
      var { employee } = action;
      return {
        ...state,
        [employee.hash_id]: employee,
      };

    case DELETED_EMPLOYEE: {
      const { [action.hash_id]: _deleted, ...newState } = state;
      return newState;
    }
    default:
      return state;
  }
}

export function ownersAsEmployeesReducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_OWNERS_AS_EMPLOYEES:
      return {
        ...state,
        ...action.payload.ownersAsEmployees,
      };

    case UPDATE_OWNER_AS_EMPLOYEE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function costEstimationReducer(state = {}, action) {
  switch (action.type) {
    case UPDATE_COST_ESTIMATION_EMPLOYEES:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}

export function requestedLifePlanQuotesReducer(state = [], action) {
  switch (action.type) {
    case UPDATE_REQUESTED_LIFE_PLANS_TO_QUOTE: {
      return action.payload;
    }
    default:
      return state;
  }
}

export function renewalPolicyReducer(state = false, action) {
  switch (action.type) {
    case INITIAL_STATE_LOADED: {
      // if there's a renewal policy in the payload, use it
      // otherwise, return the current state
      return action.payload?.renewalPolicy ?? state;
    }
    case INITIAL_STATE_LOAD_SUCCESS: {
      return action.initialState?.renewalPolicy ?? state;
    }
    default:
      return state;
  }
}

export function isLoaded(state = false, action) {
  switch (action.type) {
    case INITIAL_STATE_LOADED:
      return true;
    default:
      return state;
  }
}

export function employeeProfile(state = [], action) {
  switch (action.type) {
    case INITIAL_STATE_LOADED:
      return action.payload.employeeProfile;
    case REPLACE_EMPLOYEE_PROFILE:
      if (state.length === 0) {
        return emptyEmployeeProfile;
      }
      return action.payload;

    default:
      return state;
  }
}

export function allPlans(state = [], action) {
  switch (action.type) {
    case INITIAL_STATE_LOADED:
      return action.payload.allPlans || {};
    default:
      return state;
  }
}

export function companyProfileId(state = null, action) {
  switch (action.type) {
    case INITIAL_STATE_LOADED:
      return action.payload.companyProfileId;
    default:
      return state;
  }
}

export function currentlyEnrolledCompanyPolicyId(state = null, action) {
  switch (action.type) {
    case INITIAL_STATE_LOADED:
      return action.payload.currentlyEnrolledCompanyPolicyId;
    default:
      return state;
  }
}

export function companyProfilesReducer(state = {}, action) {
  switch (action.type) {
    case INITIAL_STATE_LOADED:
      return {
        ...state,
        ...action.payload.companyProfile,
      };

    default:
      return state;
  }
}
